const pcData = [
  // {
  //   id: "dashboard",
  //   icon: "iconsminds-compass-1",
  //   label: "menu.dashboard",
  //   to: "/dashboard",
  //   subs: [
  //     {
  //       icon: "simple-icon-paper-plane",
  //       label: "menu.running-status",
  //       to: "/dashboard/running-status"
  //     },
  //   ]
  // },

  //예약관리
  {
    id: "booking",
    icon: "simple-icon-calendar",
    label: "menu.booking",
    to: "/booking-visit",
    userRole :'ALL',
    subs: [
      // {
      //   icon: "iconsminds-calendar-4",
      //   label: "menu.booking-status",
      //   to: "/booking/booking-status"
      // },
      {
        icon: "simple-icon-paper-plane",
        label: "menu.booking-request",
        to: "/booking/booking-request"
      },
      {
        icon: "simple-icon-pin",
        label: "menu.booking-visit",
        to: "/booking/booking-visit"
      },
      // {
      //   icon: "simple-icon-logout",
      //   label: "menu.booking-cancel",
      //   to: "/booking/booking-cancel"
      // },
      // {
      //   icon:"simple-icon-login",
      //   label: "menu.booking-unvisited",
      //   to: "/booking/booking-unvisited"
      // },
      {
        icon: "simple-icon-calendar",
        label: "menu.booking-calendar",
        to: "/booking/booking-calendar"
      },
      {
        icon: "simple-icon-pencil",
        label: "menu.booking-call-reservation",
        to: "/booking/booking-call-reservation"
      },
      //외부연동관리 이동 링크 막기
      // {
      //   icon: "simple-icon-link",
      //   label: "menu.outer-connect-mng",
      //   to: "/booking/outer-connect-mng"
      // },

    ]
  },

  //쿠폰사용처리
  {
    id: "coupon",
    icon: "iconsminds-credit-card",
    label: "menu.coupon",
    to: "/coupon",
    userRole :'ALL',
    subs: [
      {
        icon: "iconsminds-dollar",
        label: "menu.coupon-search",
        to: "/coupon/coupon-search"
      }
    ]
  },
  //주문관리
  // {
  //   id: "order",
  //   icon: "iconsminds-digital-drawing",
  //   label: "menu.order",
  //   to: "/order",
  //   subs: [
  //     {
  //       icon: "iconsminds-file-clipboard-file---text",
  //       label: "menu.order-search",
  //       to: "/order/order-search"
  //     },
      // {
      //   icon: "iconsminds-folder-block",
      //   label: "menu.order-cancellantion",
      //   to: "/order/order-cancellantion"
      // },
      // {
      //   icon: "iconsminds-billing",
      //   label: "menu.evidence-request",
      //   to: "/order/evidence-request",
      // },
      // {
      //   icon: "iconsminds-box-with-folders",
      //   label: "menu.order-list",
      //   to: "/order/order-list"
      // }
    // ]
  // },

  //상품관리
  {
    id: "goods",
    icon: "iconsminds-shopping-bag",
    label: "menu.goods",
    to: "/goods",
    userRole :'BRAND',
    subs: [
      {
        icon: "iconsminds-add-bag",
        label: "menu.goods-register-status",
        to: "/goods/goods-register-status"
      },
      {
        icon: "iconsminds-receipt-4",
        label: "menu.goods-list",
        to: "/goods/goods-list"
      }
    ]
  },

  //사이트 관리
  {
    id: "siteset",
    icon: "iconsminds-project",
    label: "menu.siteSet",
    to: "/siteSet",
    userRole :'BRAND',
    subs: [
      {
        icon: "iconsminds-project",
        label: "menu.siteSet",
        to: "/siteSet/SiteSetDetail"
      },
      {
        icon: "iconsminds-speach-bubble",
        label: "menu.AlimtalkMng",
        to: "/siteSet/AlimtalkMng",
      }
    ]
  },
  //메세지 전송
  // {
  //   id: "sendmessage",
  //   icon: "iconsminds-mail-settings",
  //   label: "menu.sendMessage",
  //   to: "/sendMessage",
  //   userRole :'BRAND',
  //   subs: [
  //     {
  //       icon: "iconsminds-mail-send",
  //       label: "menu.messageSend",
  //       to: "/sendMessage/messageSend"
  //     },
  //     {
  //       icon: "iconsminds-mailbox-full",
  //       label: "menu.messageSent",
  //       to: "/sendMessage/messageSent"
  //     }
  //   ]
  // },



  //매장관리
  {
    id: "shop",
    icon: "iconsminds-shop",
    label: "menu.shop",
    to: "/shop",
    userRole :'ALL',
    subs: [
      {
        icon: "iconsminds-add-basket",
        label: "menu.shop-register-status",
        to: "/shop/shop-register-status"
      },
      {
        icon: "iconsminds-shop",
        label: "menu.shop-list",
        to: "/shop/shop-list"
      },
      {
        icon: "iconsminds-speach-bubble",
        label: "menu.AlimtalkMng",
        to: "/shop/AlimtalkMng"
      },
    ]
  },

  //정산관리
  {
    id: "sales",
    icon: "iconsminds-coins",
    label: "menu.sales",
    to: "/sales",
    userRole :'ALL',
    subs: [ {
      icon: "iconsminds-gift-box",
      label: "menu.sales-amount",
      to: "/sales/sales-amount"
    },
      {
        icon: "iconsminds-line-chart-1",
        label: "menu.sales-status",
        to: "/sales/sales-status"
      },
      {
        icon: "iconsminds-cash-register-2",
        label: "menu.settlement-status",
        to: "/sales/settlement-status"
      },
    ]
  },

  //회원관리
  {
    id: "manager",
    icon: "iconsminds-administrator",
    label: "menu.manager",
    to: "/manager",
    userRole :'ALL',
    subs: [
      {
        icon: "iconsminds-business-mens",
        label: "menu.general-member",
        to: "/manager/general-member"
      },
      {
        icon: "iconsminds-add-user",
        label: "menu.register-new-manager",
        to: "/manager/register-new-manager"
      },
      {
        icon: "iconsminds-pen",
        label: "menu.manager-list",
        to: "/manager/manager-list"
      }

    ]
  },

  //통계관리
  {
    id: "statistics",
    icon: "iconsminds-monitor-analytics",
    label: "menu.statistics",
    to: "/statistics",
    userRole :'ALL',
    subs:[
      {
        icon: "iconsminds-line-chart-1",
        label: "menu.report",
        to: "/statistics/report"
      },
      {
        icon: "iconsminds-line-chart-3",
        label: "menu.penalty",
        to: "/statistics/penalty"
      }
    ]
  },
  //공지사항
  {
    id: "notice",
    icon: "simple-icon-docs",
    label: "menu.NoticeList",
    to: "/notice/NoticeList",
    userRole :'ALL',
    subs:[
      {
        icon: "simple-icon-list",
        label: "menu.NoticeList",
        to: "/notice/NoticeList"
      }
    ]
  }
  // {
  //   id: "member",
  //   icon: "simple-icon-user",
  //   label: "menu.member",
  //   to: "/member",
  //   subs: [
  //     {
  //       icon: "iconsminds-business-mens",
  //       label: "menu.user-list",
  //       to: "/member/user-list"
  //     },
  //     {
  //       icon: "iconsminds-notepad",
  //       label: "menu.user-reviews",
  //       to: "/member/user-reviews"
  //     } ,
  //   ]
  // },
];

const mobileData = [
  {
    id: "qrCode",
    icon: "simple-icon-camrecorder",
    label: "menu.qrcode",
    to: "/qrCode",
    userRole :'ALL',
    subs: [
      {
        icon: "simple-icon-frame",
        label: "menu.qrcode",
        to: "/qrCode"
      }
    ]
  },
  {
    id: "coupon",
    icon: "iconsminds-credit-card",
    label: "menu.coupon",
    to: "/coupon",
    userRole :'STORE',
    subs: [
      {
        icon: "iconsminds-dollar",
        label: "menu.coupon-search",
        to: "/coupon/coupon-search"
      }
    ]
  },
  {
    id: "booking",
    icon: "simple-icon-calendar",
    label: "menu.booking",
    to: "/booking-visit",
    userRole :'ALL',
    subs: [
      {
        icon: "simple-icon-paper-plane",
        label: "menu.booking-request",
        to: "/booking/booking-request"
      },
      {
        icon: "simple-icon-pin",
        label: "menu.booking-visit",
        to: "/booking/booking-visit"
      },
    ]
  },
]
let dataType = "";

if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){
  dataType = pcData;
}else{
  dataType = pcData;
}

export default dataType;
